angular.module('appMarketplace')
    .service('AuthService', ['$http', 'UrlService', function ($http, UrlService) {
        var service = this;

        service.login = function (login, password, profileId, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/auth/login'),
                data: {
                    login: login,
                    password: password,
                    profileId: profileId
                }
            };

            $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data)
            })
        };

        service.passwordLookup = function (login, secret, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/auth/users/' + login + '/passwordLookup'),
                data: {
                    secret: secret
                }
            };

            $http(req).then(successCallback, function successCallbackWrapper(response) {
                errorCallback(response.data)
            })
        };

        service.getSecretQuestion = function (login, successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/auth/users/' + login + '/secretQuestion')
            };

            $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data)
            })
        };

        service.getStatus = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/auth/status')
            };

            $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data)
            })
        };
    }]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/services/auth-service.js
// module id = 53
// module chunks = 37